import React from 'react';

export default function Oops(props){
    return(
        <div>
            oops there was a mistake
        </div>
        )
}